"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("./js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { viewBox: "0 0 1152 1152" },
      _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#FF179C", d: "M0 576c0 318.1 257.9 576 576 576s576-257.9 576-576S894.1 0 576 0 0 257.9 0 576zm59.4 0C59.4 290.3 290.7 58.8 576 58.8s516.6 231.6 516.6 517.2-231.3 517.2-516.6 517.2S59.4 861.7 59.4 576z" }),
      _react2.default.createElement("path", { fill: "#321327", d: "M344.5 751.1c.7-2.2.7-5 .7-7.2 0-5.7-1.1-11.2-2.8-16.9l303.5-156.3c8.3 11.8 21.7 20.1 37.4 21.7L696.1 820c-16.2 3.3-29.1 14-36.3 28.4l-315.3-97.3zm189-466.6c9.4 14 25.6 23 43.6 23 3.9 0 7.9-.7 11.2-1.1l73.1 186.9c-8.3 5-15.1 12.3-20.1 20.6L330.9 406.2c.7-2.8 1.1-6.1 1.1-9.4 0-5-.7-10.1-2.2-15.1l203.7-97.2zM787 340.3c-.7 3.3-1.1 6.8-1.1 10.1 0 14 5 26.3 14 35.7l-85.3 107.2c-7.9-4.4-16.6-7.2-26.3-7.2-3.9 0-7.9.7-11.2 1.1L604 300.3c8.3-5 15.1-11.8 19.5-20.1L787 340.3zM879.5 616c-8.3 2.8-15.5 7.9-21.7 14.4l-119.9-72.7c2.2-5.5 3.3-11.8 3.3-18.4 0-14-5-26.3-14-35.7l85.3-107.2c7.9 4.4 16.6 7.2 26.3 7.2h1.1L879.5 616zm-580.8 74.9l-9.4-241.6c15.5-3.3 29.1-13.3 36.3-27.4l310.8 107.7c-.7 2.8-1.1 6.1-1.1 9.4 0 5.5 1.1 11.2 2.8 16.6l-303 156.3c-8.6-11.6-21.9-19.5-36.4-21zm413.4 128.2l-12.9-227.6c11.2-2.2 20.6-8.3 28-16.2l119.9 72.4c-2.2 5.7-3.3 11.8-3.3 18.4 0 12.3 4.4 24.1 11.2 32.8L735.5 828.1c-6.1-5-14.4-8.3-23.4-9zm184.7-206.3h-1.1l-39-212.7c20.6-7.2 35.2-26.7 35.2-50.3 0-29.5-23.4-53-53-53-20.1 0-37.4 11.2-46.4 27.4L629 264.5c.7-3.3 1.1-6.8 1.1-10.1 0-29.5-23.4-53-53-53-29.1 0-53 24.1-53 53 0 5 .7 10.1 2.2 15.1L322.8 367c-9.4-14-25.6-23-43.6-23-29.1 0-53 24.1-53 53 0 27.4 20.1 49.7 46.8 53l9.4 241.6c-24.5 5-42.5 26.3-42.5 51.9 0 29.5 23.4 53 53 53 20.6 0 39.2-12.3 47.5-29.5l315.4 97.6c-.7 2.2-.7 5-.7 7.2 0 29.5 23.4 53 53 53 29.1 0 53-24.1 53-53 0-12.3-4.4-24.1-11.2-32.8l119.5-128.9c8.3 5.5 18.4 9 29.5 9 29.1 0 53-24.1 53-53-1.9-29.5-25.5-53.3-55.1-53.3z" })
    )
  );
};

WrappedIcon.displayName = 'AdobeSocialColorLight';
exports.default = WrappedIcon;

